import { parseAmountInput } from '@/components/ui/fieldData';
import type { FieldDefinition, TypedFieldValue } from '@/components/objects/typedFieldData';
import type { ImportColumn, ObjectVersion, WidgetPlacement } from '@/components/object-views/viewData';
export const OBJECT_VIEWS_HOME = '/design/object-views';
export const VIEW_DEFINITIONS: FieldDefinition[] = [
  { id: 'name', label: 'Название', type: 'text', required: true, maxLength: 100 },
  { id: 'amount', label: 'Сумма', type: 'money', currency: 'RUB' },
  { id: 'active', label: 'Активно', type: 'checkbox' },
  { id: 'limit', label: 'Лимит', type: 'number', min: 0 },
  { id: 'note', label: 'Примечание', type: 'multiline' },
  { id: 'date', label: 'Дата', type: 'date' },
];
export const IMPORT_COLUMNS: ImportColumn[] = VIEW_DEFINITIONS.slice(0, 3).map((definition) => ({
  definition,
  parse(raw: string): TypedFieldValue {
    if (definition.type === 'text') return { type: 'text', value: raw };
    if (definition.type === 'money') {
      if (!raw.trim()) return { type: 'money', value: null };
      const parsed = parseAmountInput(raw, 'RUB');
      if (parsed.error || parsed.minorUnits == null) throw new Error(parsed.error ?? 'Укажи сумму.');
      return { type: 'money', value: { minorUnits: parsed.minorUnits, currency: 'RUB' } };
    }
    const key = raw.trim().toLocaleLowerCase('ru');
    if (!key) return { type: 'checkbox', value: null };
    if (['да', 'true', '1'].includes(key)) return { type: 'checkbox', value: true };
    if (['нет', 'false', '0'].includes(key)) return { type: 'checkbox', value: false };
    throw new Error('Для флажка нужны да/нет, true/false или 1/0.');
  },
}));
export const SAMPLE_CSV =
  'Название,Сумма,Активно\r\n"Проект «Лист», этап 1","12 500,00",да\r\nМастерская,0,нет\r\n"Студия\nПарус","-750,50",да';
export const INITIAL_LAYOUT: WidgetPlacement[] = [
  { widgetId: 'summary', span: 'single' },
  { widgetId: 'flow', span: 'single' },
  { widgetId: 'activity', span: 'wide' },
];
export const VERSION_BEFORE: ObjectVersion = {
  name: { type: 'text', value: 'Сезонная проверка' },
  amount: { type: 'money', value: { minorUnits: 1250000, currency: 'RUB' } },
  active: { type: 'checkbox', value: true },
  limit: { type: 'number', value: 12 },
  note: { type: 'multiline', value: null },
  date: { type: 'date', value: '2026-10-12' },
};
export const VERSION_AFTER: ObjectVersion = {
  name: { type: 'text', value: 'Сезонная проверка · завершено' },
  amount: { type: 'money', value: { minorUnits: 0, currency: 'RUB' } },
  active: { type: 'checkbox', value: false },
  limit: { type: 'number', value: 0 },
  note: { type: 'multiline', value: 'Проверка завершена.\nМожно готовить следующий этап.' },
  date: { type: 'date', value: '2026-10-12' },
};
export const SHORT_DEFINITIONS: FieldDefinition[] = [
  { id: 'limit', label: 'Лимит', type: 'number', min: 0 },
  { id: 'active', label: 'Активно', type: 'checkbox' },
];
